<template>
    <div id="header" class="hide-on-print">
        <div class="a2z-bar hide"></div>
        <!-- search viewport 1/2 -->
        <div
            id="searchArea-two-column"
            class="col-xs-12 searchbar hide hidden-md hidden-lg"
        ></div>
        <!-- /header -->
        <div class="container-fluid site-title">
            <h1>BRFSS Web Enabled Analysis Tool</h1>
            <mobile-menu v-if="showFullApp"></mobile-menu>
        </div>
        <div class="container">
            <div class="bread-crumbs-container">
                <bread-crumbs v-if="showFullApp"></bread-crumbs>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint spaced-comment: 'off' */
import breadCrumbs from '@/components/layout/breadCrumbs';
import mobileMenu from '@/components/layout/mobileMenu';
import { mapGetters, mapState } from 'vuex';

//import current from '@/scripts/current';
//import current from 'current';
export default {
    components: {
        'bread-crumbs': breadCrumbs,
        'mobile-menu': mobileMenu
    },
    props: ['showFullApp'],
    computed: {
        ...mapState({
            splashDescription: (state) => state.display.splashDescription,
            pageTitle: (state) => state.display.pageTitle
        })
    },
    updated() {
        let searchTextBoxes = document
            .getElementById('searchArea')
            .querySelectorAll('.usagov-search-autocomplete');
        if (searchTextBoxes && searchTextBoxes[0])
            searchTextBoxes[0].setAttribute('aria-label', 'Search cdc.gov');
    },
    data: () => {
        let vm = this;
        let vmData = {
            logo: '',
            search: '',
            a2zBar: ''
        };
        return vmData;
    },
    methods: {}
};
</script>
<style>
.bread-crumbs-container {
    display: none;
}

@media (min-width: 768px) {
    .bread-crumbs-container {
        display: block;
        width: 100%;
    }
}

h1 {
    font-size: 1.5rem;
    font-weight: 500;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    line-height: 1.1;
    padding: 16px 0 16px 16px;
    background-color: #4b830d;
    border-bottom: 3px solid #84bc49;
    margin-block-start: 0;
    margin-block-end: 0;
}
</style>
